import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { CreditScore } from 'types/api/creditProfile'

/* ----------------------------- CREDIT SCORE STORE ----------------------------- */

type CreditScoreState = {
  creditScore: CreditScore
}

type CreditScoreAction = {
  updateScore: (score: CreditScore) => void
}

export const useCreditScoreStore = create<
  CreditScoreState & CreditScoreAction
>()(
  persist(
    (set) => ({
      creditScore: null,
      updateScore: (score: CreditScore) => set(() => ({ creditScore: score }))
    }),
    {
      name: 'credit-score',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
